import React from 'react';
import TextInput from '../../../../components/UI/TextInput/TextInput';
import styles from './DocumentFileItem.module.scss';
import UploadStatusIndicator from './UploadStatusIndicator';

interface UploadFile {
  file: File;
  name: string;
  fiscalYear: string;
  fiscalQuarter: string;
  publishedAt: string;
  error?: string;
}

interface DocumentFileItemProps {
  file: UploadFile;
  onChange: (updates: Partial<UploadFile>) => void;
  showNameError?: boolean;
  status?: 'idle' | 'uploading' | 'success' | 'failed';
  onRetry?: () => void;
  error?: string;
}

const DocumentFileItem: React.FC<DocumentFileItemProps> = ({
  file,
  onChange,
  showNameError,
  status = 'idle',
  onRetry,
  error,
}) => {
  return (
    <div className={styles.fileItem}>
      <TextInput
        label="File Name"
        value={file.name}
        onChange={(v) => onChange({ name: v })}
        error={showNameError ? 'Duplicate file name' : undefined}
      />
      <TextInput
        label="Fiscal Year"
        value={file.fiscalYear}
        onChange={(v) => onChange({ fiscalYear: v })}
        placeholder="e.g. 2023"
        type="number"
      />
      <TextInput
        label="Fiscal Quarter"
        value={file.fiscalQuarter}
        onChange={(v) => onChange({ fiscalQuarter: v })}
        placeholder="1-4"
        type="number"
      />
      <TextInput
        label="Published At"
        value={file.publishedAt}
        onChange={(v) => onChange({ publishedAt: v })}
        placeholder="YYYY-MM-DD"
        pattern="\d{4}-\d{2}-\d{2}"
      />
      <UploadStatusIndicator status={status} onRetry={onRetry} error={error} />
    </div>
  );
};

export default DocumentFileItem;
